import { Injectable } from '@angular/core';
import { CastingTypeFormat } from 'src/app/components/att-casting-view/formats/casting-type-formats-sel/casting-type-formats-sel.component';
import { Qualifier } from 'src/app/types/qualifier';
import { CastingMode, CastingValue } from 'src/app/components/att-casting-view/att-casting-view.component';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';

@Injectable({
	providedIn: 'root'
})
export class NumberHexQualifierService implements Qualifier {
	static supportedStats = ['avg', 'count', 'first', 'last', 'max', 'median', 'min', 'sum', 'stddev'];
	static ToString(value: number, format: CastingTypeFormat): string {
		switch (format) {
			case 'hex':
				return value.toString(16).trim();
			case 'hex-c':
				return '0x' + value.toString(16).trim();
			default:
			case 'hex-hash':
				return '#' + value.toString(16).trim();
		}

	}
	static FromString(value: string, format: CastingTypeFormat): number {
		switch (format) {
			case 'hex':
				return parseInt('0x' + value, 16);
			default:
			case 'hex-c':
				return parseInt(value, 16);
			case 'hex-hash':
				return parseInt('0x' + value.substr(1), 16);
		}
	}
	public static GetDisplayValue(attribute: AttributeInfo, castingMode: CastingMode, val: any): string {
		if (!attribute.casting) {
			return val;
		}
		if (!attribute.casting[castingMode]) {
			return val;
		}
		const casting: CastingValue = attribute.casting[castingMode] as CastingValue;
		switch (attribute.type) {
			case 'text':
			case 'string':
				return val;
			default:
				return NumberHexQualifierService.ToString(val, casting.format);
		}
	}
	public static GetTextExportValue(attribute: AttributeInfo, castingMode: CastingMode, val: any): string {
		if([undefined,null].indexOf(val) > -1) {
			return '';
		}
		return NumberHexQualifierService.GetDisplayValue(attribute, castingMode, val);
	}
	public static GetNativeValue(attribute: AttributeInfo, castingMode: CastingMode, value: any): any {
		return NumberHexQualifierService.FromString(value, attribute.casting[castingMode].format);
	}
	public static SupportsStat(statName): boolean {
		return NumberHexQualifierService.supportedStats.indexOf(statName) > -1;
	}
	constructor() { }
	public static GetNumFormat():string {
		return '@';
	}
}
